// Функция для преобразования Base64URL в Uint8Array
const urlBase64ToUint8Array = (base64String) => {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding)
        .replace(/-/g, '+')
        .replace(/_/g, '/');

    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }

    return outputArray;
};

// Хук для подписки на push-уведомления
export const useSubscribe = ({ publicKey }) => {
    const setSubscription = async (subscribe) => {
        if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
            return
            throw { errorCode: "ServiceWorkerAndPushManagerNotSupported" };
        }

        const registration = await navigator?.serviceWorker?.ready;
        if (!registration.pushManager) {
            return
            throw { errorCode: "PushManagerUnavailable" };
        }

        const existingSubscription = await registration?.pushManager?.getSubscription();
        if (existingSubscription && subscribe === false) {
                await existingSubscription.unsubscribe()
        }

        if (!existingSubscription && subscribe === true) {
            const convertedVapidKey = urlBase64ToUint8Array(publicKey);
                await registration.pushManager.subscribe({
                    applicationServerKey: convertedVapidKey,
                    userVisibleOnly: true,
                });
        }
    }

    const getSubscription = async () => {
        if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
            return
            throw { errorCode: "ServiceWorkerAndPushManagerNotSupported" };
        }

        const registration = await navigator?.serviceWorker?.ready;
        if (!registration.pushManager) {
            return
            throw { errorCode: "PushManagerUnavailable" };
        }

        return await registration.pushManager.getSubscription();
    };

    return {getSubscription, setSubscription};
};